import { Box, Button, Link, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { ContentContainer } from "./components/styles"
import UIIcon from "../../components/UIIcon"

export const ErrorIdentification = () => {
  const navigate = useNavigate()
  const handleClick = () => {
    navigate("/quit", {
      replace: true,
    })
  }
  return (
    <Box sx={ContentContainer}>
      <Box
        display="flex"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
        height="100%"
        pb="150px"
        gap={4}
      >
        <UIIcon iconName="mbankIcon" size={80} />

        <Typography variant="h3" fontWeight={700} textAlign="center">
          Обновите ваши данные
        </Typography>

        <Typography variant="body1" textAlign="center">
          Для открытия «Единого кошелька» вам нужно{" "}
          <Link
            href="https://app.mbank.kg/app/update-passport?type=updatePassport"
            target="_blank"
            rel="noopener noreferrer"
          >
            обновить ваши данные в Мбанке
          </Link>
        </Typography>
      </Box>

      <Box mt="auto" sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <Typography variant="h4" textAlign="center">
          <Link
            href="https://app.mbank.kg/app/update-passport?type=updatePassport"
            target="_blank"
            rel="noopener noreferrer"
          >
            Как обновить данные{" "}
          </Link>
        </Typography>
        <Button variant="contained" color="secondary" onClick={handleClick}>
          Закрыть
        </Button>
      </Box>
    </Box>
  )
}
